import React from "react"
import { Link } from "react-router-dom"
import glamorous from "glamorous"
import { darken, lighten } from "polished"

const ActionBarText = props =>
  <StyledLink to={props.route}>
    <BarBackground tint={props.tint}>
      <Alert>
        {props.text}
      </Alert>
    </BarBackground>
  </StyledLink>

const BarBackground = glamorous.div(
  {
    fontSize: "1em",
    ":hover": {
      textDecoration: "underline",
      cursor: "pointer",
    },
  },
  ({ tint }) => ({
    backgroundColor: tint,
    ":hover": {
      backgroundColor: darken(0.02, tint),
      textDecorationColor: lighten(0.1, tint),
    },
  })
)

const Alert = glamorous.h2({
  color: "white",
  fontSize: "2em",
  fontWeight: "100",
  padding: 30,
})

const StyledLink = glamorous(Link)({
  textDecoration: "none",
})

export default ActionBarText



// WEBPACK FOOTER //
// ./src/scenes/Home/ActionBarText.js